import { SITE } from "../lib/site";

export default function Projects() {
  return (
    <div data-testid="projects-page" className="bg-[#0B0F0E]">
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 pt-20 md:pt-28 pb-16">
        <div className="overline"><span className="h-line" />Projects</div>
        <h1 className="font-display text-[#F4EFE6] text-6xl md:text-7xl lg:text-[5.5rem] mt-7 leading-[0.95] max-w-4xl">
          Selected sites — across the <span className="italic-gold">United Kingdom.</span>
        </h1>
        <p className="text-[#9BA39B] text-lg max-w-3xl mt-9 leading-relaxed">
          A representative selection of greenfield and brownfield sites currently under promotion or recently consented by Upsurge Strategic Land. Specific landowner details are kept confidential.
        </p>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 pb-28 grid md:grid-cols-2 gap-10">
        {SITE.projects.map((p, i) => (
          <article key={p.title} data-testid={`project-${i}`} className="group">
            <div className="relative overflow-hidden">
              <img src={SITE.images[p.img]} alt={p.title} className="w-full h-[460px] object-cover transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-x-0 bottom-0 p-6 bg-gradient-to-t from-[#0B0F0E] via-[#0B0F0E]/60 to-transparent">
                <div className="flex items-center gap-3 text-[10px] tracking-[0.24em] uppercase text-[#C9A24B] font-semibold">
                  <span>{p.status}</span>
                  <span className="text-[#F4EFE6]/40">·</span>
                  <span className="text-[#F4EFE6]/70">{p.type}</span>
                </div>
                <div className="font-display text-3xl md:text-4xl text-[#F4EFE6] mt-3 leading-tight">{p.title}</div>
                <div className="text-sm text-[#9BA39B] mt-1">{p.location}</div>
              </div>
            </div>
          </article>
        ))}
      </section>
    </div>
  );
}
